import { render, staticRenderFns } from "./SidebarBottomDropdown.vue?vue&type=template&id=25af4533&"
import script from "./SidebarBottomDropdown.vue?vue&type=script&lang=js&"
export * from "./SidebarBottomDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports